import React from 'react';
import styled from 'styled-components';

import { InfoNotice } from './Notices';
import { DarkLinkButton } from '../components/Buttons';

const StyledGuidanceNotice = styled(InfoNotice)`
  margin-bottom: 0;
`;

export default function GuidanceNotice() {
  return (
    <StyledGuidanceNotice>
      <h2>Veiledning</h2>

      <p>
        Ta kontakt dersom du har spørsmål eller ønsker veiledning tilknyttet
        kjøp av bildeler.
      </p>

      <DarkLinkButton to="/kundeservice">Kontakt oss</DarkLinkButton>
    </StyledGuidanceNotice>
  );
}
